import { EnvConfig } from "@superwall-editor/deploy";

  export const env: EnvConfig = {
  "deployment": {
    "sha": "3e8d5df0b56b",
    "branch": "deploy",
    "created_at": "2025-07-12T02:42:39.174Z",
    "env": "stg"
  },
  "services": {
    "@superwall-me/web": {
      "baseURL": "https://superwall.com"
    },
    "@superwall-editor/editor": {
      "baseURL": "https://v4.superwall.com/editor/sha/3e8d5df0b56b"
    },
    "@superwall-editor/preview": {
      "baseURL": "https://user-content.superwalleditor.com/preview/sha/3e8d5df0b56b"
    },
    "@superwall-editor/runtime": {
      "baseURL": "https://sw-runtime-renderer-3e8d5df0b56b.staffbar.workers.dev/runtime/sha/3e8d5df0b56b"
    }
  },
  "configuration": {
    "editor-files-bucket": "sw-editor-files-stg"
  }
};
  